import React from 'react';
import SearchableSelect from './SearchableSelect';
import type { SearchableSelectOption } from './SearchableSelect';

export interface EstadoItem {
  id?: number | string;
  uf?: string;
  sigla?: string;
  nome?: string;
}

interface StateSelectProps {
  value?: string | null;
  onChange: (value: string) => void;
  estados?: Array<EstadoItem | string>;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  className?: string;
}

const DEFAULT_ESTADOS: Array<{ sigla: string; nome: string }> = [
  { sigla: 'AC', nome: 'Acre' },
  { sigla: 'AL', nome: 'Alagoas' },
  { sigla: 'AP', nome: 'Amapá' },
  { sigla: 'AM', nome: 'Amazonas' },
  { sigla: 'BA', nome: 'Bahia' },
  { sigla: 'CE', nome: 'Ceará' },
  { sigla: 'DF', nome: 'Distrito Federal' },
  { sigla: 'ES', nome: 'Espírito Santo' },
  { sigla: 'GO', nome: 'Goiás' },
  { sigla: 'MA', nome: 'Maranhão' },
  { sigla: 'MT', nome: 'Mato Grosso' },
  { sigla: 'MS', nome: 'Mato Grosso do Sul' },
  { sigla: 'MG', nome: 'Minas Gerais' },
  { sigla: 'PA', nome: 'Pará' },
  { sigla: 'PB', nome: 'Paraíba' },
  { sigla: 'PR', nome: 'Paraná' },
  { sigla: 'PE', nome: 'Pernambuco' },
  { sigla: 'PI', nome: 'Piauí' },
  { sigla: 'RJ', nome: 'Rio de Janeiro' },
  { sigla: 'RN', nome: 'Rio Grande do Norte' },
  { sigla: 'RS', nome: 'Rio Grande do Sul' },
  { sigla: 'RO', nome: 'Rondônia' },
  { sigla: 'RR', nome: 'Roraima' },
  { sigla: 'SC', nome: 'Santa Catarina' },
  { sigla: 'SP', nome: 'São Paulo' },
  { sigla: 'SE', nome: 'Sergipe' },
  { sigla: 'TO', nome: 'Tocantins' },
];

export default function StateSelect({
  value,
  onChange,
  estados,
  disabled = false,
  required = false,
  placeholder = 'Selecione o estado...',
  className = '',
}: StateSelectProps) {
  const listaEstados = estados && estados.length > 0 ? estados : DEFAULT_ESTADOS;

  const options: SearchableSelectOption[] = listaEstados.map((estado, idx) => {
    if (typeof estado === 'string') {
      const defaultMatch = DEFAULT_ESTADOS.find((d) => d.sigla === estado.toUpperCase());
      const labelNome = defaultMatch ? `${defaultMatch.nome} (${estado})` : estado;
      return {
        id: estado,
        label: labelNome,
        value: estado,
      };
    }
    const sigla = estado.sigla || estado.uf || '';
    const nome = estado.nome || sigla;
    const label = sigla && nome && sigla !== nome ? `${nome} (${sigla})` : (nome || sigla);
    return {
      id: sigla || idx,
      label,
      value: sigla,
    };
  });

  return (
    <SearchableSelect
      options={options}
      value={value || ''}
      onChange={(val) => onChange(String(val || ''))}
      disabled={disabled}
      required={required}
      placeholder={placeholder}
      searchPlaceholder="Buscar estado..."
      className={className}
    />
  );
}
